import { $ } from "jquery";
export const app = new Object();
app.environment = import.meta.env.MODE;
app.netErr = "Please check your internet connection and try again.";
app.browserErr = "Please use Chrome/Safari/Edge/Firefox browser";
app.showAlert = (type, message) => {
  // Implementation for showing alerts
  if (type == 'error') {
    $("#alertWrapper").empty().append(
      `
        <div class="p-4 bg-error-container  rounded-lg">
          <span class="material-symbols-outlined text-error text-4xl">error</span>
          <p class="font-body-md">${message}</p>
        </div>
      `
    ).promise().done(() => {
      $("#alert-title").text("Error");
      $("#alert-subtitle").text("An error occurred");
      $("#alert")[0].showModal();
    });
  } else {
    $("#alertWrapper").empty().append(message).promise().done(() => {
      $("#alert-title").text("Alert");
      $("#alert-subtitle").text("Here's some information");
      $("#alert")[0].showModal();
    })
  }

}
/*------------------------------------*\
          Service worker
\*------------------------------------*/
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.register('/sw.js').then(sw => {
    if (window?.PushManager) {
      sw.pushManager.getSubscription().then(subscription => {
        if (subscription) {
          app.push = subscription.toJSON();
        }
      })
    }
  })
} else {
  alert(app.browserErr);
}
/*------------------------------------*\
              IndexedDB
\*------------------------------------*/
if (window?.indexedDB) {
  const openIDB = indexedDB.open(import.meta.env.VITE_APP_SHORT_NAME, 7);

  openIDB.onupgradeneeded = () => {
    app.iDB = openIDB.result;
    // object stores
    !app.iDB.objectStoreNames.contains('user') ? (app.iDB.createObjectStore('user', { keyPath: 'uuid' })) : null
    !app.iDB.objectStoreNames.contains('venues') ? (app.iDB.createObjectStore('venues', { keyPath: 'uuid' })) : null
    !app.iDB.objectStoreNames.contains('bookings') ? (app.iDB.createObjectStore('bookings', { keyPath: 'id' })) : null
    !app.iDB.objectStoreNames.contains('transactions') ? (app.iDB.createObjectStore('transactions', { keyPath: 'id' })) : null
    !app.iDB.objectStoreNames.contains('invoices') ? (app.iDB.createObjectStore('invoices', { keyPath: 'id' })) : null
    !app.iDB.objectStoreNames.contains('staff') ? (app.iDB.createObjectStore('staff', { keyPath: 'uuid' })) : null
    !app.iDB.objectStoreNames.contains('customers') ? (app.iDB.createObjectStore('customers', { keyPath: 'uuid' })) : null
    !app.iDB.objectStoreNames.contains('userActivity') ? (app.iDB.createObjectStore('userActivity', { keyPath: 'timestamp' })) : null
    !app.iDB.objectStoreNames.contains('listNowRequests') ? (app.iDB.createObjectStore('listNowRequests', { keyPath: 'id' })) : null
  }
  openIDB.onsuccess = () => {
    app.iDB = openIDB.result;
    const userTran = app.iDB.transaction("user", "readonly").objectStore("user").openCursor();
    userTran.onsuccess = (e) => {

      const cursor = e.target.result;
      if (cursor) {
        app.user = e.target.result.value;
        app.hasUser = true;
      } else {
        app.hasUser = false;
      }
      app.hasUser ?
        (async () => { let { user } = await import('./pages/user.js'); user() })() :
        (async () => { let { index } = await import('./pages/index.js'); index() })();
    }
    openIDB.result.onversionchange = (e) => {
      const oldVersion = e.oldVersion;
      const newVersion = e.newVersion;
      if (newVersion <= oldVersion) {
        app.iDB.close();
        //delete iDB and restart
        try {
          indexedDB.deleteDatabase(import.meta.env.VITE_APP_SHORT_NAME);
          history.replaceState(null, null, window.location.pathname);
          window.location.reload();
        } catch (error) {
          console.log(error);
        }
      }
    }
  }
  openIDB.onerror = () => {
    console.log(openIDB.error)
  }
  openIDB.onblocked = (e) => {
    //close connection
    app.iDB.close();
    // This fires in the NEW tab (the one trying to upgrade)
    console.log("Database upgrade blocked. Please close other tabs of this app.");
    app.showAlert("error", "Please close other open tabs of this app to allow an update.");
  };
} else { alert(app.browserErr) }
/*------------------------------------*\
            Device Validation
\*------------------------------------*/

document.addEventListener('submit', function (e) {
  if (e.target.matches('form')) {
    e.preventDefault();
  }
});

//hash string
export const hashString = async (string, alg) => {
  const stringBytes = new TextEncoder().encode(string);
  const stringBuffer = await crypto.subtle.digest(alg, stringBytes); // eg algorith: 'SHA-512'
  const stringArray = Array.from(new Uint8Array(stringBuffer));
  const stringHex = stringArray.map(b => b.toString(16).padStart(2, '0')).join('');
  return stringHex;
}